import { PenaltiesInfoEnum, } from "../../common";
export var PenaltyEnum;
(function (PenaltyEnum) {
    PenaltyEnum["NoPenalty"] = "NoPenalty";
    PenaltyEnum["NotPossible"] = "NotPossible";
    PenaltyEnum["Unknown"] = "Unknown";
    PenaltyEnum["WithFee"] = "WithFee";
})(PenaltyEnum || (PenaltyEnum = {}));
export var FeeType;
(function (FeeType) {
})(FeeType || (FeeType = {}));
export function getCancelPenalty(fare) {
    var penaltiesInfo = fare.penaltiesInfo;
    if ((penaltiesInfo === null || penaltiesInfo === void 0 ? void 0 : penaltiesInfo.PenaltiesInfo) === PenaltiesInfoEnum.Known) {
        return penaltiesInfo.cancelPenalty;
    }
    return undefined;
}
export function getChangePenalty(fare) {
    var penaltiesInfo = fare.penaltiesInfo;
    if ((penaltiesInfo === null || penaltiesInfo === void 0 ? void 0 : penaltiesInfo.PenaltiesInfo) === PenaltiesInfoEnum.Known) {
        return penaltiesInfo.changePenalty;
    }
    return undefined;
}
//# sourceMappingURL=trip-details.js.map